import { listGender } from "data/list";
import { FIELD_TYPE, FORMAT_TIME } from "types/enums";
import { DataFormField } from "types/models/input-field-type";
const { INPUT, SELECT, DATE, TEXT_AREA, COMBO_BOX } = FIELD_TYPE;
export const loaiPT = [
  { value: 1, label: "Phaco" },
  { value: 2, label: "Phaco + IOL" },
  { value: 3, label: "Mộng" },
  { value: 4, label: "U mi" },
  { value: 5, label: "Thẩm mỹ ( Lids)" },
  { value: 6, label: "U kết mạc" },
  { value: 7, label: "Quặm" },
  { value: 8, label: "IOL thì 2" },
  { value: 9, label: "Hạ nhãn áp" },
  { value: 10, label: "Tiêm nội nhãn" },
  { value: 11, label: "Chụp FA" },
  { value: 12, label: "Rửa tiền phòng" },
  { value: 13, label: "Bóc màng võng + Cắt dịch kính sau" },
  { value: 14, label: "Cắt dịch kính trước" },
  { value: 15, label: "Cắt dịch kính trước + IOL thì 2" },
  { value: 16, label: "Khác" },
];
const fields = () => {
  const fields: DataFormField[] = [
    {
      type: DATE,
      label: "Ngày tạo",
      name: "ngayTao",
      optionsTime: { showTime: true, format: FORMAT_TIME.dateTime },
      disable: true,
    },
    {
      type: INPUT,
      label: "Số điện thoại",
      name: "dienThoai",
      disable: true,
    },
    {
      type: TEXT_AREA,
      label: "Địa chỉ",
      name: "diaChiTongHop",
      disable: true,
    },

    {
      type: SELECT,
      label: "Loại KCB",
      name: "loaiKCB",
      options: JSON.parse(localStorage.getItem("loaiKCB")),
      disable: true,
      // placeholder: "Không có",
    },
    {
      type: INPUT,
      label: "Thân nhân",
      name: "thanNhan",
      disable: true,
    },
    {
      type: INPUT,
      label: "BS chỉ định",
      name: "bacSyChiDinh",
      disable: true,
    },
    {
      type: SELECT,
      label: "Trạng thái TV",
      name: "trangThai",
      options: JSON.parse(localStorage.getItem("TTPhieu")),
      disable: true,
      // placeholder: "Không có",
    },
    {
      type: INPUT,
      label: "Nhân viên TV",
      name: "nvTuVan",
    },
    {
      type: TEXT_AREA,
      label: "Lý do khám",
      // css: {
      //   xl: 16,
      //   lg: 12,
      //   md: 24,
      //   sm: 24,
      //   xs: 24,
      // },
      // labelCol: { xs: 10, md: 8, lg: 8, xl: 4 },
      // wrapperCol: { xs: 14, md: 16, lg: 16, xl: 20 },
      name: "lyDoKham",
      disable: true,
    },
    {
      type: COMBO_BOX,
      label: "Chuyển phòng",
      name: "phong",
      rules: [
        { required: true, message: "Bắt buộc phải chọn phòng tiếp theo!" },
      ],
      allowClear: false,
      options: JSON.parse(localStorage.getItem("phongKhamYesPeople")),
    },
    {
      type: SELECT,
      label: "Loại phẫu thuật",
      name: "loaiPhauThuat",
      allowClear: true,
      options: loaiPT,
      mode: "tags",
    },
  ];

  return fields;
};

export { fields };
